import { render, staticRenderFns } from "./goodsInventoryCreate.vue?vue&type=template&id=63e8b0b5&scoped=true"
import script from "./goodsInventoryCreate.vue?vue&type=script&lang=js"
export * from "./goodsInventoryCreate.vue?vue&type=script&lang=js"
import style0 from "./goodsInventoryCreate.vue?vue&type=style&index=0&id=63e8b0b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e8b0b5",
  null
  
)

export default component.exports